module.exports = "/assets/data/be73edf4ba92bf815312ccb5b0558b2b-B8.data.json";